// extracted by mini-css-extract-plugin
module.exports = {"toaster":"Toaster_toaster__31r9t","toast":"Toaster_toast__1qZDw"};